
// // src/components/UploadField.jsx
// import React, { useState } from 'react';
// import api from '../services/api';

// const UploadField = ({
//   documentType,
//   documentsList = [],
//   onUploadSuccess,
//   expiryRequired = false,
//   showNotAvailable = false,
//   notAvailableLabel = "Not Available",
//   consentText = "",
//   mandatory = false,
//   disabled = false,
//   instruction = "",
//   isLocked = false,
//   allowDeleteWhenLocked = false
// }) => {
//   const [file, setFile] = useState(null);
//   const [expiryDate, setExpiryDate] = useState('');
//   const [uploading, setUploading] = useState(false);
//   const [error, setError] = useState('');
//   const [isNotAvailable, setIsNotAvailable] = useState(false);
//   const [consentChecked, setConsentChecked] = useState(false);

//   // Find if this document type is already uploaded (handle US Passport, Highest Ed Certificate, and Employment Letters fallbacks)
//   const existingDoc = documentsList.find(doc =>
//     doc.document_type === documentType ||
//     (documentType === "Passport" && (doc.document_type === "US Passport" || doc.document_type === "Passport / Greencard / EAD")) ||
//     ((documentType === "Visa & EAD" || documentType === "Visa / EAD" || documentType === "Visa and EAD") && (doc.document_type === "Visa & EAD" || doc.document_type === "Visa / Greencard / EAD" || doc.document_type === "Visa / EAD" || doc.document_type === "Visa and EAD" || doc.document_type === "EAD" || doc.document_type === "Greencard")) ||
//     (documentType === "Highest Education Qualification (Degree Certificate/Transcript)" && doc.document_type === "Highest Educational Certificate") ||
//     (documentType === "Last Held Employement offer letter" && (doc.document_type === "Previous Employment Letters" || doc.document_type === "Last field employment offer letter")) ||
//     (documentType === "Void Cheque" && (doc.document_type === "Cancelled Cheque" || doc.document_type === "Bank Proof")) ||
//     (documentType === "Additional supporting Documents (if any)" && doc.document_type === "Additional Supporting Documents")
//   );

//   const handleFileChange = (e) => {
//     setFile(e.target.files[0]);
//     setError('');
//   };

//   const handleUpload = async (e) => {
//     e.preventDefault();
//     if (!isNotAvailable && !file) {
//       setError('Please select a file first.');
//       return;
//     }

//     if (!isNotAvailable && expiryRequired && !expiryDate) {
//       setError('Expiry date is required for this document.');
//       return;
//     }

//     if (isNotAvailable && consentText && !consentChecked) {
//       setError('Please agree to the consent statement first.');
//       return;
//     }

//     setUploading(true);
//     setError('');

//     const formData = new FormData();
//     formData.append('document_type', documentType);
//     if (isNotAvailable) {
//       formData.append('is_not_available', '1');
//       if (consentText) {
//         formData.append('comments', 'Consent given: ' + consentText);
//       }
//     } else {
//       formData.append('file', file);
//       if (expiryDate) {
//         formData.append('expiry_date', expiryDate);
//       }
//     }

//     try {
//       await api.post('/onboarding/documents', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       setFile(null);
//       setExpiryDate('');
//       setIsNotAvailable(false);
//       setConsentChecked(false);
//       if (onUploadSuccess) onUploadSuccess();
//     } catch (err) {
//       setError(err.response?.data?.error || 'Failed to upload document.');
//     } finally {
//       setUploading(false);
//     }
//   };

//   const handleDelete = async () => {
//     if (!existingDoc) return;
//     if (!window.confirm(`Are you sure you want to delete your uploaded ${documentType}?`)) return;

//     try {
//       await api.delete('/onboarding/documents', {
//         data: { id: existingDoc.id }
//       });
//       if (onUploadSuccess) onUploadSuccess();
//     } catch (err) {
//       alert(err.response?.data?.error || 'Failed to delete document.');
//     }
//   };

//   return (
//     <div style={{ padding: '1rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)', marginBottom: '1rem', backgroundColor: 'var(--bg-secondary)' }}>
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '0.5rem' }}>
//         <div>
//           <h4 style={{ fontSize: '0.95rem', fontWeight: 600, margin: 0 }}>
//             {documentType} {(expiryRequired || mandatory) && <span style={{ color: 'var(--danger)' }}>*</span>}
//           </h4>
//           {instruction && (
//             <p style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', marginTop: '0.25rem', margin: 0 }}>
//               {instruction}
//             </p>
//           )}
//         </div>
//       </div>

//       {existingDoc ? (
//         <div>
//           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', flexWrap: 'wrap', fontSize: '0.825rem', color: 'var(--text-secondary)' }}>
//             <div>
//               {existingDoc.file_path === 'NOT_AVAILABLE' ? (
//                 <p style={{ fontStyle: 'italic', color: 'var(--text-tertiary)' }}>
//                   Marked as Not Available
//                 </p>
//               ) : (
//                 <>
//                   <p>Uploaded: <strong>{new Date(existingDoc.uploaded_at).toLocaleDateString()}</strong></p>
//                   {existingDoc.expiry_date && <p>Expires: <strong>{existingDoc.expiry_date}</strong></p>}
//                 </>
//               )}
//             </div>
//             <div style={{ display: 'flex', gap: '0.5rem' }}>
//               {existingDoc.file_path !== 'NOT_AVAILABLE' && (
//                 <a
//                   href={`/EOP_api/${existingDoc.file_path}`}
//                   target="_blank"
//                   rel="noreferrer"
//                   className="btn btn-secondary"
//                   style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem' }}
//                 >
//                   View/Download
//                 </a>
//               )}
//               {(!isLocked || allowDeleteWhenLocked) && (
//                 <button
//                   type="button"
//                   className="btn btn-danger"
//                   style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem' }}
//                   onClick={handleDelete}
//                 >
//                   Delete
//                 </button>
//               )}
//             </div>
//           </div>
//           {existingDoc.comments && (
//             <div style={{ marginTop: '0.5rem', padding: '0.5rem 0.75rem', backgroundColor: existingDoc.file_path === 'NOT_AVAILABLE' ? 'var(--bg-tertiary)' : 'var(--danger-light)', borderLeft: existingDoc.file_path === 'NOT_AVAILABLE' ? '3px solid var(--primary)' : '3px solid var(--danger)', fontSize: '0.75rem', color: 'var(--text-primary)', borderRadius: '0 var(--border-radius-sm) var(--border-radius-sm) 0' }}>
//               {existingDoc.file_path === 'NOT_AVAILABLE' ? (
//                 <span><strong>Consent given:</strong> {existingDoc.comments.replace(/^Consent given:\s*/, '')}</span>
//               ) : (
//                 <span><strong>HR Comment:</strong> {existingDoc.comments}</span>
//               )}
//             </div>
//           )}
//         </div>
//       ) : (
//         <form onSubmit={handleUpload} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//           {showNotAvailable && (
//             <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
//               <input
//                 type="checkbox"
//                 id={`not-available-${documentType.replace(/\s+/g, '-')}`}
//                 checked={isNotAvailable}
//                 onChange={(e) => {
//                   setIsNotAvailable(e.target.checked);
//                   setError('');
//                 }}
//               />
//               <label
//                 htmlFor={`not-available-${documentType.replace(/\s+/g, '-')}`}
//                 style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer', fontWeight: 500 }}
//               >
//                 {notAvailableLabel}
//               </label>
//             </div>
//           )}

//           {isNotAvailable && consentText && (
//             <div style={{ padding: '0.75rem', backgroundColor: 'var(--bg-tertiary)', borderLeft: '3px solid var(--primary)', borderRadius: 'var(--border-radius-sm)', marginBottom: '0.25rem' }}>
//               <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}>
//                 <input
//                   type="checkbox"
//                   id={`consent-${documentType.replace(/\s+/g, '-')}`}
//                   checked={consentChecked}
//                   onChange={(e) => {
//                     setConsentChecked(e.target.checked);
//                     setError('');
//                   }}
//                   style={{ marginTop: '0.125rem' }}
//                 />
//                 <label
//                   htmlFor={`consent-${documentType.replace(/\s+/g, '-')}`}
//                   style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', cursor: 'pointer', lineHeight: '1.4' }}
//                 >
//                   {consentText}
//                 </label>
//               </div>
//             </div>
//           )}

//           <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'flex-end' }}>
//             {!isNotAvailable && (
//               <div style={{ flex: '1 1 200px' }}>
//                 <input
//                   type="file"
//                   className="form-control"
//                   accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
//                   onChange={handleFileChange}
//                   style={{ padding: '0.375rem 0.75rem' }}
//                 />
//               </div>
//             )}
//             {!isNotAvailable && expiryRequired && (
//               <div style={{ flex: '0 0 150px' }}>
//                 <label style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', display: 'block', marginBottom: '0.25rem' }}>Expiry Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   value={expiryDate}
//                   onChange={(e) => setExpiryDate(e.target.value)}
//                   style={{ padding: '0.375rem 0.75rem' }}
//                 />
//               </div>
//             )}
//             <div>
//               <button
//                 type="submit"
//                 className="btn btn-primary"
//                 disabled={uploading || (!isNotAvailable && !file) || (isNotAvailable && consentText && !consentChecked)}
//                 style={{ padding: '0.5rem 1rem' }}
//               >
//                 {uploading ? 'Processing...' : (isNotAvailable ? 'Confirm Not Available' : 'Upload File')}
//               </button>
//             </div>
//           </div>
//           {error && <p style={{ color: 'var(--danger)', fontSize: '0.75rem' }}>{error}</p>}
//           {!isNotAvailable && (
//             <p style={{ color: 'var(--text-tertiary)', fontSize: '0.7rem' }}>Supported formats: PDF, DOC, DOCX, PNG, JPG (Max 5MB)</p>
//           )}
//         </form>
//       )}
//     </div>
//   );
// };

// export default UploadField;
























// // src/components/UploadField.jsx
// import React, { useState } from 'react';
// import api from '../services/api';
// import Loader from './Loader';

// const UploadField = ({
//   documentType,
//   documentsList = [],
//   onUploadSuccess,
//   expiryRequired = false,
//   showNotAvailable = false,
//   notAvailableLabel = "Not Available",
//   consentText = "",
//   mandatory = false,
//   disabled = false,
//   instruction = "",
//   isLocked = false,
//   allowDeleteWhenLocked = false
// }) => {
//   const [file, setFile] = useState(null);
//   const [expiryDate, setExpiryDate] = useState('');
//   const [uploading, setUploading] = useState(false);
//   const [error, setError] = useState('');
//   const [isNotAvailable, setIsNotAvailable] = useState(false);
//   const [consentChecked, setConsentChecked] = useState(false);

//   // Find if this document type is already uploaded (handle US Passport, Highest Ed Certificate, and Employment Letters fallbacks)
//   const existingDoc = documentsList.find(doc =>
//     doc.document_type === documentType ||
//     (documentType === "Passport" && (doc.document_type === "US Passport" || doc.document_type === "Passport / Greencard / EAD")) ||
//     ((documentType === "Visa & EAD" || documentType === "Visa / EAD" || documentType === "Visa and EAD") && (doc.document_type === "Visa & EAD" || doc.document_type === "Visa / Greencard / EAD" || doc.document_type === "Visa / EAD" || doc.document_type === "Visa and EAD" || doc.document_type === "EAD" || doc.document_type === "Greencard")) ||
//     (documentType === "Highest Education Qualification (Degree Certificate/Transcript)" && doc.document_type === "Highest Educational Certificate") ||
//     (documentType === "Last Held Employement offer letter" && (doc.document_type === "Previous Employment Letters" || doc.document_type === "Last field employment offer letter")) ||
//     (documentType === "Void Cheque" && (doc.document_type === "Cancelled Cheque" || doc.document_type === "Bank Proof")) ||
//     (documentType === "Additional supporting Documents (if any)" && doc.document_type === "Additional Supporting Documents")
//   );

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     if (selectedFile) {
//       if (selectedFile.size > 5 * 1024 * 1024) {
//         setError('This file is not accepted. File size exceeds maximum limit of 5MB.');
//         setFile(null);
//         e.target.value = '';
//         return;
//       }
//       const allowedExts = ['pdf', 'doc', 'docx', 'png', 'jpg', 'jpeg'];
//       const ext = selectedFile.name.split('.').pop().toLowerCase();
//       if (!allowedExts.includes(ext)) {
//         setError('This file is not accepted. Allowed formats: PDF, DOC, DOCX, PNG, JPG, JPEG.');
//         setFile(null);
//         e.target.value = '';
//         return;
//       }
//     }
//     setFile(selectedFile);
//     setError('');
//   };

//   const handleUpload = async (e) => {
//     e.preventDefault();
//     if (!isNotAvailable && !file) {
//       setError('Please select a file first.');
//       return;
//     }

//     if (!isNotAvailable && expiryRequired && !expiryDate) {
//       setError('Expiry date is required for this document.');
//       return;
//     }

//     if (isNotAvailable && consentText && !consentChecked) {
//       setError('Please agree to the consent statement first.');
//       return;
//     }

//     setUploading(true);
//     setError('');

//     const formData = new FormData();
//     formData.append('document_type', documentType);
//     if (isNotAvailable) {
//       formData.append('is_not_available', '1');
//       if (consentText) {
//         formData.append('comments', 'Consent given: ' + consentText);
//       }
//     } else {
//       formData.append('file', file);
//       if (expiryDate) {
//         formData.append('expiry_date', expiryDate);
//       }
//     }

//     try {
//       await api.post('/onboarding/documents', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       setFile(null);
//       setExpiryDate('');
//       setIsNotAvailable(false);
//       setConsentChecked(false);
//       if (onUploadSuccess) onUploadSuccess();
//     } catch (err) {
//       setError(err.response?.data?.error || 'Failed to upload document.');
//     } finally {
//       setUploading(false);
//     }
//   };

//   const handleDelete = async () => {
//     if (!existingDoc) return;
//     if (!window.confirm(`Are you sure you want to delete your uploaded ${documentType}?`)) return;

//     try {
//       await api.delete('/onboarding/documents', {
//         data: { id: existingDoc.id }
//       });
//       if (onUploadSuccess) onUploadSuccess();
//     } catch (err) {
//       alert(err.response?.data?.error || 'Failed to delete document.');
//     }
//   };

//   return (
//     <div style={{ padding: '1rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)', marginBottom: '1rem', backgroundColor: 'var(--bg-secondary)' }}>
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '0.5rem' }}>
//         <div>
//           <h4 style={{ fontSize: '0.95rem', fontWeight: 600, margin: 0 }}>
//             {documentType} {(expiryRequired || mandatory) && <span style={{ color: 'var(--danger)' }}>*</span>}
//           </h4>
//           {instruction && (
//             <p style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', marginTop: '0.25rem', margin: 0 }}>
//               {instruction}
//             </p>
//           )}
//         </div>
//       </div>

//       {existingDoc ? (
//         <div>
//           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', flexWrap: 'wrap', fontSize: '0.825rem', color: 'var(--text-secondary)' }}>
//             <div>
//               {existingDoc.file_path === 'NOT_AVAILABLE' ? (
//                 <p style={{ fontStyle: 'italic', color: 'var(--text-tertiary)' }}>
//                   Marked as Not Available
//                 </p>
//               ) : (
//                 <>
//                   <p>Uploaded: <strong>{new Date(existingDoc.uploaded_at).toLocaleDateString()}</strong></p>
//                   {existingDoc.expiry_date && <p>Expires: <strong>{existingDoc.expiry_date}</strong></p>}
//                 </>
//               )}
//             </div>
//             <div style={{ display: 'flex', gap: '0.5rem' }}>
//               {existingDoc.file_path !== 'NOT_AVAILABLE' && (
//                 <a
//                   href={`/EOP_api/${existingDoc.file_path}`}
//                   target="_blank"
//                   rel="noreferrer"
//                   className="btn btn-secondary"
//                   style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem' }}
//                 >
//                   View/Download
//                 </a>
//               )}
//               {(!isLocked || allowDeleteWhenLocked) && (
//                 <button
//                   type="button"
//                   className="btn btn-danger"
//                   style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem' }}
//                   onClick={handleDelete}
//                 >
//                   Delete
//                 </button>
//               )}
//             </div>
//           </div>
//           {existingDoc.comments && (
//             <div style={{ marginTop: '0.5rem', padding: '0.5rem 0.75rem', backgroundColor: existingDoc.file_path === 'NOT_AVAILABLE' ? 'var(--bg-tertiary)' : 'var(--danger-light)', borderLeft: existingDoc.file_path === 'NOT_AVAILABLE' ? '3px solid var(--primary)' : '3px solid var(--danger)', fontSize: '0.75rem', color: 'var(--text-primary)', borderRadius: '0 var(--border-radius-sm) var(--border-radius-sm) 0' }}>
//               {existingDoc.file_path === 'NOT_AVAILABLE' ? (
//                 <span><strong>Consent given:</strong> {existingDoc.comments.replace(/^Consent given:\s*/, '')}</span>
//               ) : (
//                 <span><strong>HR Comment:</strong> {existingDoc.comments}</span>
//               )}
//             </div>
//           )}
//         </div>
//       ) : (
//         <form onSubmit={handleUpload} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
//           {showNotAvailable && (
//             <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
//               <input
//                 type="checkbox"
//                 id={`not-available-${documentType.replace(/\s+/g, '-')}`}
//                 checked={isNotAvailable}
//                 onChange={(e) => {
//                   setIsNotAvailable(e.target.checked);
//                   setError('');
//                 }}
//               />
//               <label
//                 htmlFor={`not-available-${documentType.replace(/\s+/g, '-')}`}
//                 style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer', fontWeight: 500 }}
//               >
//                 {notAvailableLabel}
//               </label>
//             </div>
//           )}

//           {isNotAvailable && consentText && (
//             <div style={{ padding: '0.75rem', backgroundColor: 'var(--bg-tertiary)', borderLeft: '3px solid var(--primary)', borderRadius: 'var(--border-radius-sm)', marginBottom: '0.25rem' }}>
//               <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}>
//                 <input
//                   type="checkbox"
//                   id={`consent-${documentType.replace(/\s+/g, '-')}`}
//                   checked={consentChecked}
//                   onChange={(e) => {
//                     setConsentChecked(e.target.checked);
//                     setError('');
//                   }}
//                   style={{ marginTop: '0.125rem' }}
//                 />
//                 <label
//                   htmlFor={`consent-${documentType.replace(/\s+/g, '-')}`}
//                   style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', cursor: 'pointer', lineHeight: '1.4' }}
//                 >
//                   {consentText}
//                 </label>
//               </div>
//             </div>
//           )}

//           <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'flex-end' }}>
//             {!isNotAvailable && (
//               <div style={{ flex: '1 1 200px' }}>
//                 <input
//                   type="file"
//                   className="form-control"
//                   accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
//                   onChange={handleFileChange}
//                   style={{ padding: '0.375rem 0.75rem' }}
//                 />
//               </div>
//             )}
//             {!isNotAvailable && expiryRequired && (
//               <div style={{ flex: '0 0 150px' }}>
//                 <label style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', display: 'block', marginBottom: '0.25rem' }}>Expiry Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   value={expiryDate}
//                   onChange={(e) => setExpiryDate(e.target.value)}
//                   style={{ padding: '0.375rem 0.75rem' }}
//                 />
//               </div>
//             )}
//             <div>
//               <button
//                 type="submit"
//                 className="btn btn-primary"
//                 disabled={uploading || (!isNotAvailable && !file) || (isNotAvailable && consentText && !consentChecked)}
//                 style={{ padding: '0.5rem 1rem' }}
//               >
//                 {uploading ? <><Loader inline size="sm" /> Processing...</> : (isNotAvailable ? 'Confirm Not Available' : 'Upload File')}
//               </button>
//             </div>
//           </div>
//           {error && <p style={{ color: 'var(--danger)', fontSize: '0.75rem' }}>{error}</p>}
//           {!isNotAvailable && (
//             <p style={{ color: 'var(--text-tertiary)', fontSize: '0.7rem' }}>Supported formats: PDF, DOC, DOCX, PNG, JPG (Max 5MB)</p>
//           )}
//         </form>
//       )}
//     </div>
//   );
// };

// export default UploadField;




























// src/components/UploadField.jsx
import React, { useState } from 'react';
import api from '../services/api';
import Loader from './Loader';

const UploadField = ({
  documentType,
  documentsList = [],
  onUploadSuccess,
  expiryRequired = false,
  showNotAvailable = false,
  notAvailableLabel = "Not Available",
  consentText = "",
  mandatory = false,
  disabled = false,
  instruction = "",
  isLocked = false,
  allowDeleteWhenLocked = false
}) => {
  const [file, setFile] = useState(null);
  const [expiryDate, setExpiryDate] = useState('');
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [isNotAvailable, setIsNotAvailable] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);

  // Find if this document type is already uploaded (handle US Passport, Highest Ed Certificate, and Employment Letters fallbacks)
  const existingDoc = documentsList.find(doc =>
    doc.document_type === documentType ||
    (documentType === "Passport" && (doc.document_type === "US Passport" || doc.document_type === "Passport / Greencard / EAD")) ||
    ((documentType === "Visa & EAD" || documentType === "Visa / EAD" || documentType === "Visa and EAD") && (doc.document_type === "Visa & EAD" || doc.document_type === "Visa / Greencard / EAD" || doc.document_type === "Visa / EAD" || doc.document_type === "Visa and EAD" || doc.document_type === "EAD" || doc.document_type === "Greencard")) ||
    (documentType === "Highest Education Qualification (Degree Certificate/Transcript)" && doc.document_type === "Highest Educational Certificate") ||
    (documentType === "Last Held Employement offer letter" && (doc.document_type === "Previous Employment Letters" || doc.document_type === "Last field employment offer letter")) ||
    (documentType === "Void Cheque" && (doc.document_type === "Cancelled Cheque" || doc.document_type === "Bank Proof")) ||
    (documentType === "Additional supporting Documents (if any)" && doc.document_type === "Additional Supporting Documents")
  );

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 5 * 1024 * 1024) {
        setError('This file is not accepted. File size exceeds maximum limit of 5MB.');
        setFile(null);
        e.target.value = '';
        return;
      }
      const allowedExts = ['pdf', 'doc', 'docx', 'png', 'jpg', 'jpeg'];
      const ext = selectedFile.name.split('.').pop().toLowerCase();
      if (!allowedExts.includes(ext)) {
        setError('This file is not accepted. Allowed formats: PDF, DOC, DOCX, PNG, JPG, JPEG.');
        setFile(null);
        e.target.value = '';
        return;
      }
    }
    setFile(selectedFile);
    setError('');
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!isNotAvailable && !file) {
      setError('Please select a file first.');
      return;
    }

    if (!isNotAvailable && expiryRequired && !expiryDate) {
      setError('Expiry date is required for this document.');
      return;
    }

    if (isNotAvailable && consentText && !consentChecked) {
      setError('Please agree to the consent statement first.');
      return;
    }

    setUploading(true);
    setError('');

    const formData = new FormData();
    formData.append('document_type', documentType);
    if (isNotAvailable) {
      formData.append('is_not_available', '1');
      if (consentText) {
        formData.append('comments', 'Consent given: ' + consentText);
      }
    } else {
      formData.append('file', file);
      if (expiryDate) {
        formData.append('expiry_date', expiryDate);
      }
    }

    try {
      await api.post('/onboarding/documents', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setFile(null);
      setExpiryDate('');
      setIsNotAvailable(false);
      setConsentChecked(false);
      window.dispatchEvent(new Event('onboarding_updated'));
      if (onUploadSuccess) onUploadSuccess();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to upload document.');
    } finally {
      setUploading(false);
    }
  };

  const handleDelete = async () => {
    if (!existingDoc) return;
    if (!window.confirm(`Are you sure you want to delete your uploaded ${documentType}?`)) return;

    try {
      await api.delete('/onboarding/documents', {
        data: { id: existingDoc.id }
      });
      window.dispatchEvent(new Event('onboarding_updated'));
      if (onUploadSuccess) onUploadSuccess();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to delete document.');
    }
  };

  return (
    <div style={{ padding: '1rem', border: '1px solid var(--border-color)', borderRadius: 'var(--border-radius-sm)', marginBottom: '1rem', backgroundColor: 'var(--bg-secondary)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '0.5rem' }}>
        <div>
          <h4 style={{ fontSize: '0.95rem', fontWeight: 600, margin: 0 }}>
            {documentType} {(expiryRequired || mandatory) && <span style={{ color: 'var(--danger)' }}>*</span>}
          </h4>
          {instruction && (
            <p style={{ fontSize: '0.78rem', color: 'var(--text-secondary)', marginTop: '0.25rem', margin: 0 }}>
              {instruction}
            </p>
          )}
        </div>
      </div>

      {existingDoc ? (
        <div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', flexWrap: 'wrap', fontSize: '0.825rem', color: 'var(--text-secondary)' }}>
            <div>
              {existingDoc.file_path === 'NOT_AVAILABLE' ? (
                <p style={{ fontStyle: 'italic', color: 'var(--text-tertiary)' }}>
                  Marked as Not Available
                </p>
              ) : (
                <>
                  <p>Uploaded: <strong>{new Date(existingDoc.uploaded_at).toLocaleDateString()}</strong></p>
                  {existingDoc.expiry_date && <p>Expires: <strong>{existingDoc.expiry_date}</strong></p>}
                </>
              )}
            </div>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              {existingDoc.file_path !== 'NOT_AVAILABLE' && (
                <a
                  href={`/EOP_api/${existingDoc.file_path}`}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-secondary"
                  style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem' }}
                >
                  View/Download
                </a>
              )}
              {(!isLocked || allowDeleteWhenLocked) && (
                <button
                  type="button"
                  className="btn btn-danger"
                  style={{ padding: '0.35rem 0.75rem', fontSize: '0.75rem' }}
                  onClick={handleDelete}
                >
                  Delete
                </button>
              )}
            </div>
          </div>
          {existingDoc.comments && (
            <div style={{ marginTop: '0.5rem', padding: '0.5rem 0.75rem', backgroundColor: existingDoc.file_path === 'NOT_AVAILABLE' ? 'var(--bg-tertiary)' : 'var(--danger-light)', borderLeft: existingDoc.file_path === 'NOT_AVAILABLE' ? '3px solid var(--primary)' : '3px solid var(--danger)', fontSize: '0.75rem', color: 'var(--text-primary)', borderRadius: '0 var(--border-radius-sm) var(--border-radius-sm) 0' }}>
              {existingDoc.file_path === 'NOT_AVAILABLE' ? (
                <span><strong>Consent given:</strong> {existingDoc.comments.replace(/^Consent given:\s*/, '')}</span>
              ) : (
                <span><strong>HR Comment:</strong> {existingDoc.comments}</span>
              )}
            </div>
          )}
        </div>
      ) : (
        <form onSubmit={handleUpload} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {showNotAvailable && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.25rem' }}>
              <input
                type="checkbox"
                id={`not-available-${documentType.replace(/\s+/g, '-')}`}
                checked={isNotAvailable}
                onChange={(e) => {
                  setIsNotAvailable(e.target.checked);
                  setError('');
                }}
              />
              <label
                htmlFor={`not-available-${documentType.replace(/\s+/g, '-')}`}
                style={{ fontSize: '0.85rem', color: 'var(--text-primary)', cursor: 'pointer', fontWeight: 500 }}
              >
                {notAvailableLabel}
              </label>
            </div>
          )}

          {isNotAvailable && consentText && (
            <div style={{ padding: '0.75rem', backgroundColor: 'var(--bg-tertiary)', borderLeft: '3px solid var(--primary)', borderRadius: 'var(--border-radius-sm)', marginBottom: '0.25rem' }}>
              <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-start' }}>
                <input
                  type="checkbox"
                  id={`consent-${documentType.replace(/\s+/g, '-')}`}
                  checked={consentChecked}
                  onChange={(e) => {
                    setConsentChecked(e.target.checked);
                    setError('');
                  }}
                  style={{ marginTop: '0.125rem' }}
                />
                <label
                  htmlFor={`consent-${documentType.replace(/\s+/g, '-')}`}
                  style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', cursor: 'pointer', lineHeight: '1.4' }}
                >
                  {consentText}
                </label>
              </div>
            </div>
          )}

          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'flex-end' }}>
            {!isNotAvailable && (
              <div style={{ flex: '1 1 200px' }}>
                <input
                  type="file"
                  className="form-control"
                  accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                  onChange={handleFileChange}
                  style={{ padding: '0.375rem 0.75rem' }}
                />
              </div>
            )}
            {!isNotAvailable && expiryRequired && (
              <div style={{ flex: '0 0 150px' }}>
                <label style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', display: 'block', marginBottom: '0.25rem' }}>Expiry Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={expiryDate}
                  onChange={(e) => setExpiryDate(e.target.value)}
                  style={{ padding: '0.375rem 0.75rem' }}
                />
              </div>
            )}
            <div>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={uploading || (!isNotAvailable && !file) || (isNotAvailable && consentText && !consentChecked)}
                style={{ padding: '0.5rem 1rem' }}
              >
                {uploading ? <><Loader inline size="sm" /> Processing...</> : (isNotAvailable ? 'Confirm Not Available' : 'Upload File')}
              </button>
            </div>
          </div>
          {error && <p style={{ color: 'var(--danger)', fontSize: '0.75rem' }}>{error}</p>}
          {!isNotAvailable && (
            <p style={{ color: 'var(--text-tertiary)', fontSize: '0.7rem' }}>Supported formats: PDF, DOC, DOCX, PNG, JPG (Max 1MB)</p>
          )}
        </form>
      )}
    </div>
  );
};

export default UploadField;
